import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

import { getImagesByQuery } from './js/pixabay-api';
import {
  createGallery,
  clearGallery,
  showLoader,
  hideLoader,
  refs,
  showLoadMoreButton,
  hideLoadMoreButton,
} from './js/render-functions';
import errorIcon from './img/errorIcon.svg';

let currentQuery = '';
let currentPage = 1;
let totalPages = 0;

hideLoadMoreButton();

document.addEventListener('DOMContentLoaded', () => {
  refs.searchForm.addEventListener('submit', async event => {
    event.preventDefault();

    const query = refs.searchForm.elements['search-text'].value.trim();

    if (!query) {
      iziToast.show({
        message: 'Please enter a search query!',
        iconUrl: errorIcon,
        backgroundColor: '#ef4040',
        messageColor: '#fff',
        titleColor: '#fff',
        messageSize: '16px',
        position: 'topRight',
        close: false,
      });
      return;
    }

    if (query !== currentQuery) {
      currentQuery = query;
      currentPage = 1;
      clearGallery();
      hideLoadMoreButton();
    }

    showLoader();

    try {
      const data = await getImagesByQuery(currentQuery, currentPage);

      if (data.hits.length === 0) {
        iziToast.show({
          message:
            'Sorry, there are no images matching your search query. Please try again!',
          iconUrl: errorIcon,
          backgroundColor: '#ef4040',
          messageColor: '#fff',
          titleColor: '#fff',
          messageSize: '16px',
          position: 'topRight',
          close: false,
        });
        hideLoadMoreButton();
        return;
      }
      createGallery(data.hits);

      totalPages = Math.ceil(data.totalHits / 15);

      if (currentPage < totalPages) {
        showLoadMoreButton();
      } else {
        hideLoadMoreButton();
      }
      currentPage += 1;
    } catch (err) {
      console.error(err);
      iziToast.show({
        message: 'Error while loading images. Please try again later.',
        backgroundColor: '#ef4040',
        messageColor: '#fff',
        position: 'topRight',
      });
    } finally {
      hideLoader();
    }
  });

  refs.loadMoreBtn.addEventListener('click', async () => {
    showLoader();
    try {
      const data = await getImagesByQuery(currentQuery, currentPage);

      if (data.hits.length > 0) {
        createGallery(data.hits);
        const card = document.querySelector('.gallery-item');
        if (card) {
          const { height: cardHeight } = card.getBoundingClientRect();
          window.scrollBy({
            top: cardHeight * 2,
            behavior: 'smooth',
          });
        }
      }
      if (currentPage >= Math.ceil(data.totalHits / 15)) {
        hideLoadMoreButton();
        iziToast.show({
          message: "We're sorry, but you've reached the end of search results.",
          iconUrl: errorIcon,
          backgroundColor: '#ef4040',
          messageColor: '#fff',
          titleColor: '#fff',
          messageSize: '16px',
          position: 'topRight',
          close: false,
        });
      } else {
        showLoadMoreButton();
      }
      currentPage += 1;
    } catch (err) {
      console.error(err);
      iziToast.show({
        message: 'Error while loading images. Please try again later.',
        iconUrl: errorIcon,
        backgroundColor: '#ef4040',
        messageColor: '#fff',
        titleColor: '#fff',
        messageSize: '16px',
        position: 'topRight',
        close: false,
      });
    } finally {
      hideLoader();
    }
  });
});
